import UserEntity from "./UserEntity";
import UserInput from "../1_Inputs/UserInput";

export const userEntity = (params: UserInput) => new UserEntity({ ...params });
